var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1611 7.75632L11.8326 10.237C12.0558 10.4443 12.0558 10.7802 11.8326 10.9874C11.6095 11.1947 11.2477 11.1947 11.0245 10.9874L8.35296 8.50672C7.47315 9.16024 6.35715 9.55102 5.14286 9.55102C2.30254 9.55102 0 7.41295 0 4.77551C0 2.13807 2.30254 0 5.14286 0C7.98318 0 10.2857 2.13807 10.2857 4.77551C10.2857 5.90307 9.86488 6.93935 9.1611 7.75632ZM5.14286 8.4898C7.352 8.4898 9.14286 6.82685 9.14286 4.77551C9.14286 2.72417 7.352 1.06122 5.14286 1.06122C2.93372 1.06122 1.14286 2.72417 1.14286 4.77551C1.14286 6.82685 2.93372 8.4898 5.14286 8.4898Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.af3c836235d996a05ea5bf68c8acab92.svg";
export { ForwardRef as ReactComponent };